<script setup lang="ts">
import TermsAndConditionsDialog from "@/components/dialogs/TermsAndConditionsDialog.vue";
import { useTermsReacceptance } from "@/composables/useTermsReacceptance";

const { showDialog, current, acceptCurrent, declineCurrent } = useTermsReacceptance();
</script>

<template>
  <TermsAndConditionsDialog
    v-if="current"
    :model-value="showDialog"
    :title="current.title"
    :html-content="current.htmlContent"
    :notice="current.notice"
    @accept="acceptCurrent"
    @decline="declineCurrent"
  />
</template>
